module.exports = __webpack_public_path__ + "44581fc25ba2f33a7a8efdc469859bbb.pdf";